import { render } from "./MetaMaskConnect.vue?vue&type=template&id=2a7b68ef&scoped=true"
import script from "./MetaMaskConnect.vue?vue&type=script&lang=js"
export * from "./MetaMaskConnect.vue?vue&type=script&lang=js"

import "./MetaMaskConnect.vue?vue&type=style&index=0&id=2a7b68ef&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2a7b68ef"

export default script